export const DEFAULT_TEXTS = {
    TITLE: "Sorry, We are not able to show the bill",
    DESCRIPTION: "Please retry or call the waiter directly",
    IMG_URL:
        "https://media-assets.swiggy.com/portal/static-assets/images/digital-menu/all-theme-assets/bill_error2.png",
    CTA_TEXT: "Retry",
};

export const BILL_TIMEOUT_TEXTS = {
    TITLE: "Try notifying the restaurant again",
    CTA_TEXT: "Retry",
};

export const BILL_SUMMARY_PENDING_STATUS_CODE = 8;
export const BILL_SUMMARY_SUCCESS_STATUS_CODE = 0;

export const BILL_SUMMARY_EMPTY_STATE = {
    WIDTH: 220,
    HEIGHT: 200,
};

export const BOTTOM_WIDGET_HEIGHT = {
    BASE: 150,
    PER_NUDGE: 30,
};
